import React from "react";
//#region types
import { NavigationListProps, NavListItemProps } from "models/propTypes/navListPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Icon } from "components/common";
import { TreeView } from "@mui/lab";
import NavigationTreeItem from "./treeItem";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const NavigationTreeView: React.FC<NavListItemProps & NavigationListProps> = (props) => {
  return (
    <TreeView
      className={cssExports.navListTree}
      defaultCollapseIcon={<Icon icon={IconDefinitionConstants.WArrowCollapse} className={cssExports.navIcon} />}
      defaultExpanded={["root"]}
      defaultExpandIcon={<Icon icon={IconDefinitionConstants.WArrowExpand} className={cssExports.navIcon} />}
    >
      <NavigationTreeItem node={props} root parentPath="" collapsed={props.collapsed} />
    </TreeView>
  );
};

export default NavigationTreeView;
